var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2885 17.67C10.2885 17.67 10.2885 20.0941 10.2885 5.45673C10.2885 3.92733 9.04863 2.6875 7.51923 2.6875C5.98983 2.6875 4.75 3.92733 4.75 5.45673V7.5625H10.2885",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2885 13.727C10.2885 13.727 10.2885 11.1862 10.2885 25.8235C10.2885 27.3529 11.5283 28.5928 13.0577 28.5928C14.5871 28.5928 15.8269 27.3529 15.8269 25.8235L15.8269 23.7178L29.9974 23.7178L29.9974 25.2341",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9974 24.9152L29.9974 25.8235C29.9974 27.3529 28.7576 28.5928 27.2282 28.5928L13.0036 28.5927",
    stroke: "#201D1D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 2.6875C7.31251 2.6875 15.9539 2.6875 22.0192 2.6875C23.5486 2.6875 24.7885 3.92733 24.7885 5.45673C24.7885 20.0941 24.7885 22.4375 24.7885 22.4375C24.7885 22.8362 24.8039 23.2068 24.8357 23.5502",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 10.2537H14.0409",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 13.8914H14.0409",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 17.6211H14.0409",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.110a7e493ff568608d31ff8486c2eb2b.svg";
export { ForwardRef as ReactComponent };